import Connection from './connection'
import PaginatedStore from './paginated_store'
import api from '../api'

export default class Leads extends PaginatedStore {
  constructor(scope) {
    super(new Connection('leads', scope))
  }

  search(value) {
    // TODO: Shouldn't this be passing website_uuid as well, not website_id?
    return api.get(this.connection.url(), { params: { ...this.connection.scope, registered: true, search:value } })
      .then(resp => this.records = resp.data)
  }

  assignTo(lead_id, user_id) {
    return this.update({
      ...this.findById(lead_id),
      assigned_to_id: user_id
    })
  }

  unassign(lead_id) {
    return this.update({
      ...this.findById(lead_id),
      assigned_to_id: null
    })
  }

  addNote(lead_id, message) {
    return api.post(`${this.connection.url(lead_id)}/notes`, { message }).then(resp => {
      this.findById(lead_id).lead_notes = [...this.findById(lead_id).lead_notes, resp.data]
    })
  }

  removeNote(lead_id, note_id) {
    return api.delete(`${this.connection.url(lead_id)}/notes/${note_id}`).then(() => {
      const oldNotes = this.findById(lead_id).lead_notes
      const newNotes = oldNotes.filter(oldNote => oldNote.id != note_id)
      this.findById(lead_id).lead_notes = newNotes
    })
  }

  addTag(lead_id, tag_id) {
    return api.post(`${this.connection.url(lead_id)}/tags`, { tag_id }).then(resp => {
      this.findById(lead_id).lead_tags.push(resp.data)
    })
  }

  removeTag(lead_id, lead_tag_id) {
    const params = { lead_tag_id }
    return api.delete(`${this.connection.url(lead_id)}/tags`, { params }).then(() => {
      const lead = this.findById(lead_id)
      const index = lead.lead_tags.findIndex( lt => lt.id === lead_tag_id )
      lead.lead_tags.splice(index, 1)
    })
  }
}



// WEBPACK FOOTER //
// client/stores/leads.js